import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInformation: {
    auth_token: "",
    user_id: null,
    user_role_id: null,
    role_name: "",
    fullname: "",
    info_completed: false,
    subscription_start: "",
    subscription_end: "",
    expiration_date: null,
    is_verified: false,
    has_payments: false,
  },
  userRegisterInformation: {
    user_email: "",
    password: "",
    user_id: "",
  },
};

export const UserInformationSlice = createSlice({
  name: "userInformation",
  initialState,
  reducers: {
    setCheckoutUserInformation(state, { payload }) {
      state.userRegisterInformation = payload;
    },
    setUserInformation(state, { payload }) {
      state.userInformation = payload;
    },
    setUserFullname(state, { payload }) {
      state.userInformation.fullname = payload;
    },
    setInfoCompleted(state, { payload }) {
      state.userInformation.info_completed = payload;
    },
    setCheckoutUserId(state, { payload }) {
      state.userRegisterInformation.user_id = payload;
    },
    setCheckoutUserEmail(state, { payload }) {
      state.userRegisterInformation.user_email = payload;
    },

    resetUserInformation: () => initialState,
  },
});

export const {
  setUserInformation,
  setCheckoutUserInformation,
  resetUserInformation,
  setUserFullname,
  setInfoCompleted,
  setCheckoutUserId,
  setCheckoutUserEmail,
} = UserInformationSlice.actions;

export const selectUserInformation = (state) => state.user.userInformation;
export const selectUserEmail = (state) => state.user.userInformation.email;
export const selectUserCheckoutInformation = (state) => state.user.userRegisterInformation;
export const selectUserCheckoutEmail = (state) => state.user.userRegisterInformation.user_email;
export const selectIsVerifiedUser = (state) => state.user.userInformation.is_verified;
export const selectUserInfoComplete = (state) => state.user.userInformation.info_completed;
export const selectFullUserName = (state) => state.user.userInformation.fullname;
export const selectCheckoutUserId = (state) => state.user.userRegisterInformation.user_id;
export const selectUserId = (state) => state.user.userInformation.user_id;

/** id para checkout: primero el de registro/login previo a pago; si no, sesión (ej. invitado desde plataforma). */
export const selectEffectiveCheckoutUserId = (state) => {
  const regId = state.user.userRegisterInformation.user_id;
  if (regId !== null && regId !== undefined && regId !== "") return regId;
  const sessionId = state.user.userInformation.user_id;
  if (sessionId !== null && sessionId !== undefined && sessionId !== "") return sessionId;
  return "";
};
export const selectAuthToken = (state) => state.user.userInformation.auth_token;
export const selectIsGuestUserRole = (state) => state.user.userInformation.role_name === "Invitado";

export default UserInformationSlice.reducer;
